"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.certificateMapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Business = _interopRequireDefault(require("@material-ui/icons/Business"));

var _Directions = _interopRequireDefault(require("@material-ui/icons/Directions"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Category = _interopRequireDefault(require("@material-ui/icons/Category"));

var _certificateColors = _interopRequireDefault(require("./certificateColors"));

var _ProfileItem = _interopRequireDefault(require("../ProfileItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var certificateMapper = function certificateMapper(_ref, unit, manufacturer) {
  var productionUnit = _ref.productionUnit,
      isValid = _ref.isValid,
      inOpschorting = _ref.inOpschorting,
      inToelating = _ref.inToelating,
      validityRange = _ref.validityRange,
      validSince = _ref.validSince,
      types = _ref.types,
      rootManufacturer = _ref.manufacturer;
  var withKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var labels = arguments.length > 4 ? arguments[4] : undefined;

  var _manufacturer = manufacturer || rootManufacturer || productionUnit && productionUnit.manufacturer;

  var _unit = unit || productionUnit;

  return {
    isValid: isValid,
    validityLabel: inToelating ? labels.validity('inToelating') : inOpschorting ? labels.validity('inOpschorting', {
      date: validSince
    }) : isValid ? labels.validity('valid', {
      date: validityRange
    }) : labels.validity('inValid', {
      date: validityRange
    }),
    owner: withKey ? "".concat(_unit.key, " - ").concat(_manufacturer.name) : _manufacturer.name,
    ownerLabel: _manufacturer.location && _manufacturer.location.formatted_address,
    production: _unit && _unit.location && _unit.location.formatted_address,
    productionLabel: labels.table.unit,
    types: types,
    labels: labels
  };
};

exports.certificateMapper = certificateMapper;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return _objectSpread(_objectSpread({}, (0, _certificateColors["default"])('backgroundColor')), (0, _certificateColors["default"])('color', function (a) {
    return "".concat(a, "Color");
  }));
});

var CertificateProfile = function CertificateProfile(_ref2) {
  var isValid = _ref2.isValid,
      validityLabel = _ref2.validityLabel,
      owner = _ref2.owner,
      ownerLabel = _ref2.ownerLabel,
      production = _ref2.production,
      productionLabel = _ref2.productionLabel,
      hideOwner = _ref2.hideOwner,
      onClickOwner = _ref2.onClickOwner,
      onClickProduction = _ref2.onClickProduction,
      types = _ref2.types,
      labels = _ref2.labels;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.List, {
    disablePadding: true
  }, /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    className: isValid ? classes.green : classes.red,
    icon: isValid ? /*#__PURE__*/_react["default"].createElement(_Done["default"], null) : /*#__PURE__*/_react["default"].createElement(_Close["default"], null),
    text: validityLabel
  }), !hideOwner ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Business["default"], null),
    textLabel: ownerLabel,
    text: owner,
    onClick: onClickOwner
  }), /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Directions["default"], null),
    textLabel: productionLabel,
    text: production,
    onClick: onClickProduction
  })) : '', types && types.map(function (type) {
    return /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
      icon: /*#__PURE__*/_react["default"].createElement(_Category["default"], null),
      textLabel: type.title,
      text: "".concat(labels.productTypes, ": ").concat(type.key)
    });
  }));
};

var _default = CertificateProfile;
exports["default"] = _default;